import { DeviceControlExclusionsWebComponent } from './component/DeviceControlExclusionsWebComponent';

export { DeviceControlExclusionsWebComponent };
